import React from 'react';
import { useCandidateUrl } from 'domain/shared/candidate';
import { FieldProps, LinkField, useFieldHelper } from 'framework/ui/field';

const CandidateLinkFieldWithName = ({ source, nameSource, ...props }: FieldProps) => {
  const { getValue: getId } = useFieldHelper({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { getSingleEntityUrl } = useCandidateUrl();

  const id = getId();
  const value = id && getSingleEntityUrl(id);

  return <LinkField {...props} linkText={nameSource ? getName() : id} value={value as string} isInternal={false} />;
};

export default CandidateLinkFieldWithName;
